export var getDataFromQRCMapper = function (data) {
    var result = [];
    if (data && data.length > 0) {
        result = data === null || data === void 0 ? void 0 : data.map(function (item) {
            return {
                Id: item.id,
                AcCode: item.acCode,
                AcName: item.acName,
                CategoryId: item.categoryId,
                CategoryName: item.categoryName,
                CallTypeId: item.callTypeId,
                CallTypeName: item.callTypeName,
                SubTypeId: item.subTypeId,
                SubTypeName: item.subTypeName,
                RefNumber: item.refNumber,
                Descriptions: item.descriptions,
                AssignTeamCode: item.assignTeamCode,
                AssignTeamName: item.assignTeamName,
                StatusId: item.statusId,
                Status: item.status,
                SubStatusId: item.subStatusId,
                SubStatus: item.subStatus,
                TAT: item.tat,
                AssignType: item.assignType,
                SourceCode: item.sourceCode,
                SourceName: item.sourceName,
                AssinIndividualName: item.assinIndividualName,
                AssinIndividualCode: item.assinIndividualCode,
                CreatedBy: item.createdBy,
                AssignDate: item.assignDate,
                CreatedDate: item.createdDate,
                DueDate: item.dueDate,
                Remark: item.remark,
                Reason: item.reason,
                ServiceRequestID: item.serviceRequestID,
                TicketID: item.ticketID,
                ClientTier: item.clientTier,
                CreatedUser: item.createdUser,
                TimeTaken: item.timeTaken,
            };
        });
    }
    return result;
};
